import React, { useState } from 'react';
import { Box, TextField, Select, MenuItem, InputAdornment, FormControl, InputLabel } from '@mui/material';

const countryCodes = [
    { code: '+91', name: 'India' },
    { code: '+1', name: 'USA' },
    { code: '+44', name: 'UK' },
    { code: '+61', name: 'Australia' },
    { code: '+81', name: 'Japan' },
    { code: '+49', name: 'Germany' },
    { code: '+33', name: 'France' },
    { code: '+39', name: 'Italy' },
    { code: '+86', name: 'China' },
    { code: '+7', name: 'Russia' },
    { code: '+82', name: 'South Korea' },
    { code: '+55', name: 'Brazil' },
    { code: '+34', name: 'Spain' },
    { code: '+31', name: 'Netherlands' },
    { code: '+41', name: 'Switzerland' },
    { code: '+90', name: 'Turkey' },
    { code: '+52', name: 'Mexico' },
    { code: '+46', name: 'Sweden' },
    { code: '+32', name: 'Belgium' },
    { code: '+47', name: 'Norway' },
    { code: '+48', name: 'Poland' },
    { code: '+45', name: 'Denmark' },
    { code: '+65', name: 'Singapore' },
    { code: '+27', name: 'South Africa' },
    { code: '+43', name: 'Austria' },
    { code: '+420', name: 'Czech Republic' },
    { code: '+358', name: 'Finland' },
    { code: '+30', name: 'Greece' },
    { code: '+353', name: 'Ireland' },
    { code: '+54', name: 'Argentina' },
    { code: '+372', name: 'Estonia' },
    { code: '+370', name: 'Lithuania' },
    { code: '+371', name: 'Latvia' },
    { code: '+56', name: 'Chile' },
    { code: '+60', name: 'Malaysia' },
    { code: '+66', name: 'Thailand' },
    { code: '+62', name: 'Indonesia' },
    { code: '+63', name: 'Philippines' },
    { code: '+234', name: 'Nigeria' },
    { code: '+20', name: 'Egypt' },
    { code: '+212', name: 'Morocco' },
    { code: '+84', name: 'Vietnam' },
    { code: '+92', name: 'Pakistan' },
    { code: '+880', name: 'Bangladesh' },
    { code: '+972', name: 'Israel' },
    { code: '+994', name: 'Azerbaijan' },
    { code: '+375', name: 'Belarus' },
    { code: '+373', name: 'Moldova' },
    { code: '+995', name: 'Georgia' },
    { code: '+380', name: 'Ukraine' },
    { code: '+48', name: 'Poland' },
    { code: '+386', name: 'Slovenia' },
    { code: '+421', name: 'Slovakia' },
    { code: '+40', name: 'Romania' },
    { code: '+36', name: 'Hungary' },
    { code: '+381', name: 'Serbia' },
    { code: '+382', name: 'Montenegro' },
    { code: '+389', name: 'North Macedonia' },
    { code: '+357', name: 'Cyprus' },
    { code: '+359', name: 'Bulgaria' },
    { code: '+386', name: 'Slovenia' },
    { code: '+373', name: 'Moldova' },
    { code: '+994', name: 'Azerbaijan' },
    { code: '+374', name: 'Armenia' },
    { code: '+998', name: 'Uzbekistan' },
    { code: '+993', name: 'Turkmenistan' },
    { code: '+996', name: 'Kyrgyzstan' },
    { code: '+992', name: 'Tajikistan' },
    { code: '+976', name: 'Mongolia' },
    { code: '+86', name: 'China' },
    { code: '+82', name: 'South Korea' },
    { code: '+81', name: 'Japan' },
    { code: '+65', name: 'Singapore' },
    { code: '+855', name: 'Cambodia' },
    { code: '+856', name: 'Laos' },
    { code: '+95', name: 'Myanmar' },
    { code: '+94', name: 'Sri Lanka' },
    { code: '+960', name: 'Maldives' },
    { code: '+92', name: 'Pakistan' },
    { code: '+880', name: 'Bangladesh' },
    { code: '+977', name: 'Nepal' },
    { code: '+91', name: 'India' },
    { code: '+98', name: 'Iran' },
    { code: '+964', name: 'Iraq' },
    { code: '+962', name: 'Jordan' },
    { code: '+961', name: 'Lebanon' },
    { code: '+963', name: 'Syria' },
    { code: '+970', name: 'Palestine' },
    { code: '+972', name: 'Israel' },
    { code: '+965', name: 'Kuwait' },
    { code: '+968', name: 'Oman' },
    { code: '+974', name: 'Qatar' },
    { code: '+966', name: 'Saudi Arabia' },
    { code: '+971', name: 'United Arab Emirates' },
    { code: '+973', name: 'Bahrain' },
    { code: '+20', name: 'Egypt' },
    { code: '+212', name: 'Morocco' },
    { code: '+216', name: 'Tunisia' },
    { code: '+218', name: 'Libya' },
    { code: '+254', name: 'Kenya' },
    { code: '+256', name: 'Uganda' },
    { code: '+255', name: 'Tanzania' },
    { code: '+233', name: 'Ghana' },
    { code: '+234', name: 'Nigeria' },
    { code: '+27', name: 'South Africa' },
    // Add more countries as needed
];

const MobileNumberInput = ({ cMobile, cCode, onChange }) => {
    const [countryCode, setCountryCode] = useState(cCode || '+91');
    const [number, setNumber] = useState(cMobile || '');
    const [error, setError] = useState('');

    const handleCountryChange = (e) => {
        setCountryCode(e.target.value);
        if (onChange) onChange(e.target.value, number);
    };

     // Add this effect to sync number with cMobile prop
    React.useEffect(() => {
        setNumber(cMobile || '');
    }, [cMobile]);

    React.useEffect(() => {
        setCountryCode(cCode || '+91');
    }, [cCode]);

    const handleNumberChange = (e) => {
        const val = e.target.value.replace(/\D/g, '');
        setNumber(val);
        let err = '';
        if (countryCode === '+91') {
            // Indian mobile numbers: 10 digits, starts with 6-9
            const isValid = /^([6-9]\d{9})$/.test(val);
            if (!isValid && val.length === 10) {
                err = 'Invalid Indian mobile number';
            }
        }
        setError(err);
        if (!err && onChange) onChange(countryCode, val);
    };

    return (
        <Box display="flex" alignItems="center" gap={2}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="country-code-label">Country</InputLabel>
                <Select
                    labelId="country-code-label"
                    value={countryCode}
                    label="Country"
                    onChange={handleCountryChange}
                >
                    {countryCodes.map((c) => (
                        <MenuItem key={c.code} value={c.code}>
                            {c.name} ({c.code})
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                type="tel"
                label="Mobile Number"
                value={number}
                onChange={handleNumberChange}
                error={!!error}
                helperText={error || ''}
                size="small"
                sx={{ flex: 1 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">{countryCode}</InputAdornment>
                    ),
                }}
                placeholder="Enter mobile number"
            />
        </Box>
    );
};

export default MobileNumberInput;